/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RichtextFacet from '../richtext/facet.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'

const $nsid = 'app.bsky.feed.generator'

export { $nsid }

/** Record declaring of the existence of a feed generator, and containing metadata about it. The record can exist in any repository. */
type Main = {
  $type: 'app.bsky.feed.generator'
  did: l.DidString
  displayName: string
  description?: string
  descriptionFacets?: RichtextFacet.Main[]
  avatar?: l.BlobRef

  /**
   * Declaration that a feed accepts feedback interactions from a client through app.bsky.feed.sendInteractions
   */
  acceptsInteractions?: boolean

  /**
   * Self-label values
   */
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject
  contentMode?:
    | 'app.bsky.feed.defs#contentModeUnspecified'
    | 'app.bsky.feed.defs#contentModeVideo'
    | l.UnknownString
  createdAt: l.DatetimeString
}

export type { Main }

/** Record declaring of the existence of a feed generator, and containing metadata about it. The record can exist in any repository. */
const main = l.record<'any', Main>(
  'any',
  $nsid,
  l.object({
    did: l.string({ format: 'did' }),
    displayName: l.string({ maxGraphemes: 24, maxLength: 240 }),
    description: l.optional(l.string({ maxGraphemes: 300, maxLength: 3000 })),
    descriptionFacets: l.optional(
      l.array(l.ref<RichtextFacet.Main>((() => RichtextFacet.main) as any)),
    ),
    avatar: l.optional(
      l.blob({ accept: ['image/png', 'image/jpeg'], maxSize: 1000000 }),
    ),
    acceptsInteractions: l.optional(l.boolean()),
    labels: l.optional(
      l.typedUnion(
        [l.typedRef<LabelDefs.SelfLabels>((() => LabelDefs.selfLabels) as any)],
        false,
      ),
    ),
    contentMode: l.optional(
      l.string<{
        knownValues: [
          'app.bsky.feed.defs#contentModeUnspecified',
          'app.bsky.feed.defs#contentModeVideo',
        ]
      }>(),
    ),
    createdAt: l.string({ format: 'datetime' }),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
